import { AuthenticationType } from '../enums/authentication-type.enum';
import { AuthenticationCredentials } from './authentication-credentials.interface';

export class Authentication {
  authenticationType?: AuthenticationType;
  credentials?: AuthenticationCredentials; // only for OAuth2.0, for a salesforce integration
  secondaryCredentials?: AuthenticationCredentials; // only for OAuth2.0, for a salesforce integration
  accessTokenUrl?: string; // only for OAuth2.0
}
